import * as React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';

import {
  Text,
  IconRegularDelivery,
  IconSolidInfo,
  TooltipModel,
} from '@notino/react-styleguide';

import { PortalTooltip } from '@components/PortalTooltip';
import PriceLabel from '@components/PriceLabel';
import { useIsDualPrice } from '@containers/ProductDetailContainer/ProductDetail/hooks/useIsDualPrice';

import { DiscountWrapper } from '../styled';

import { Condition } from './components/Condition';
import { messages } from './messages';
import { IConditionalFreeDelivery } from './model';
import { ConditionalTooltipContent, DualPriceWrapper } from './styled';
import {
  Wrapper,
  LabelRow,
  PriceWrapper,
  WrapperComponent,
  LineSeparator,
  PriceSplitter,
} from './styled';

interface IConditionalFreeDeliveryProps {
  conditionalFreeDelivery: IConditionalFreeDelivery;
  leftPadding?: boolean;
}

const ConditionalFreeDelivery: React.FC<IConditionalFreeDeliveryProps> = ({
  conditionalFreeDelivery,
  leftPadding,
}) => {
  const { formatMessage } = useIntl();

  const { type, value, targets } = conditionalFreeDelivery;

  const {
    isDualPrice,
    getLeftSideFormattedPrice,
    getRightSideFormattedPrice,
    leftSideCurrency,
    rightSideCurrency,
  } = useIsDualPrice();

  return (
    <DiscountWrapper>
      <Wrapper leftPadding={leftPadding}>
        <LabelRow>
          <IconRegularDelivery
            color="icon.highlight"
            width="1.25rem"
            height="1.25rem"
          />

          <Text typography="labelRegular" block={true}>
            {formatMessage(messages[`delivery${type}`], {
              value: type === 'Piece' && value,
              price:
                type === 'Price' &&
                (isDualPrice ? (
                  <DualPriceWrapper>
                    <div>
                      {getLeftSideFormattedPrice(value)} {leftSideCurrency}
                    </div>

                    <PriceSplitter>/</PriceSplitter>

                    <div>
                      {getRightSideFormattedPrice(value)} {rightSideCurrency}
                    </div>
                  </DualPriceWrapper>
                ) : (
                  <PriceLabel
                    currencyComponent={PriceWrapper}
                    wrapperComponent={WrapperComponent}
                    price={{ value: value }}
                  />
                )),
            })}
          </Text>
        </LabelRow>

        <Condition targets={targets}>
          <PortalTooltip
            interactive={true}
            position={TooltipModel.Position.topCenter}
            content={
              <PortalTooltip.Content>
                <ConditionalTooltipContent>
                  <FormattedMessage {...messages.tooltipInfo} />
                </ConditionalTooltipContent>
              </PortalTooltip.Content>
            }
          >
            <IconSolidInfo width="13px" height="13px" color="icon.disabled" />
          </PortalTooltip>
        </Condition>
      </Wrapper>

      <LineSeparator />
    </DiscountWrapper>
  );
};

export default ConditionalFreeDelivery;
